import React, { useEffect } from "react";
import CreateExcel from "../../../shared/createExcel";
import { Typography, Box } from "@mui/material";

const CreateExcelDeliverySampleShuttle = ({
  allBookingDeliverySampleShuttle,
  openDeliverySampleListDownload,
}) => {
  const excelName = "รายงานการจองรถรับส่งตัวอย่างการทดลอง";
  const excelHeaderAndWidth = [
    { header: "ลำดับ", width: 15 },
    { header: "ชื่อตัวอย่าง", width: 30 },
    { header: "เกรด", width: 15 },
    { header: "Lot Number", width: 30 },
    { header: "รายละเอียด", width: 50 },
    { header: "ชื่อผู้ส่ง", width: 30 },
    { header: "เบอร์โทรผู้ส่ง", width: 30 },
    { header: "จุดรับของต้นทาง", width: 50 },
    { header: "วันที่ส่ง", width: 20 },
    { header: "เวลารับของต้นทาง", width: 20 },
    { header: "ชื่อผู้รับ", width: 30 },
    { header: "เบอร์โทรศัพท์ผู้รับของ", width: 30 },
    { header: "จุดปลายทาง", width: 50 },
    { header: "วันที่รับของ", width: 20 },
    { header: "เวลารับของ", width: 20 },
    { header: "ชื่อคนขับรถ", width: 30 },
    { header: "สถานะ", width: 30 },
  ];
  const excelHeader = excelHeaderAndWidth.map((item) => item.header);
  const excelColumnWidth = excelHeaderAndWidth.map((item) => item.width);

  const tempAllData = [];
  const tempWaitingForPickup = [];
  const tempPickedUp = [];
  const tempDelivered = [];
  const tempCompleted = [];

  const excelCategories = [
    { title: "สถานะทั้งหมด", data: tempAllData },
    { title: "สถานะรอรับสินค้า", data: tempWaitingForPickup },
    { title: "รับสินค้าเรียบร้อย", data: tempPickedUp },
    { title: "ส่งสินค้าเรียบร้อย", data: tempDelivered },
    { title: "ได้รับสินค้าเรียบร้อย", data: tempCompleted },
  ];

  useEffect(() => {
    if (openDeliverySampleListDownload) {
      let globalOrder = 0;
      let waitingForPickupOrder = 0;
      let pickedUpOrder = 0;
      let deliveredOrder = 0;
      let completedOrder = 0;

      tempAllData.length = 0;
      tempWaitingForPickup.length = 0;
      tempPickedUp.length = 0;
      tempDelivered.length = 0;
      tempCompleted.length = 0;

      const statusOrder = [
        "รอรับสินค้า",
        "รับสินค้าเรียบร้อย",
        "ส่งสินค้าเรียบร้อย",
        "ได้รับสินค้าเรียบร้อย",
      ];

      const allDataUnsorted = [];

      statusOrder.forEach((status) => {
        allBookingDeliverySampleShuttle[status]?.forEach((item) => {
          const transformedItem = {
            order: ++globalOrder,
            nameSample: item.nameSample || "",
            nameGrade: item.nameGrade || "",
            lotNumber: item.lotNumber || "",
            detail: item.detail || "",
            nameSender: item.nameSender || "",
            phoneSender: item.phoneSender || "",
            fromPlace: item.fromPlaceName || "",
            rawDate: item.date,
            date: item.date
              ? new Date(item.date).toLocaleDateString("th-TH", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : "",
            startTime: item.startTime || "",
            nameRecipient: item.nameRecipient || "",
            phoneRecipient: item.phoneRecipient || "",
            toPlace: item.toPlaceName || "",
            completedDate: item.completedDate
              ? new Date(item.completedDate).toLocaleDateString("th-TH", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : "",
            completedTime: item.completedDate
              ? new Date(item.completedDate).toLocaleTimeString("th-TH", {
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : "",
            nameDriver: item.driverFullName
              ? item.driverFullName
              : "",
            status: item.status,
          };

          allDataUnsorted.push(transformedItem);

          const { rawDate, ...restTransformedItem } = transformedItem;

          if (status === "รอรับสินค้า") {
            tempWaitingForPickup.push({
              ...restTransformedItem,
              order: ++waitingForPickupOrder,
            });
          }
          if (status === "รับสินค้าเรียบร้อย") {
            tempPickedUp.push({
              ...restTransformedItem,
              order: ++pickedUpOrder,
            });
          }
          if (status === "ส่งสินค้าเรียบร้อย") {
            tempDelivered.push({
              ...restTransformedItem,
              order: ++deliveredOrder,
            });
          }
          if (status === "ได้รับสินค้าเรียบร้อย") {
            tempCompleted.push({
              ...restTransformedItem,
              order: ++completedOrder,
            });
          }
        });
      });

      // Already sort by date & time
      // time: when retrieving db sql & date: sorted here
      allDataUnsorted.sort((a, b) => {
        return a.rawDate < b.rawDate ? 1 : a.rawDate > b.rawDate ? -1 : 0;
      });

      allDataUnsorted.map((item, index) => {
        const { rawDate, ...restItem } = item;
        tempAllData.push({
          ...restItem,
          order: index + 1,
        });
      });
    }
  }, [openDeliverySampleListDownload]);

  return (
    <div>
      {excelCategories.map(({ title, data }, index) => (
        <Box
          sx={{
            paddingBottom: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
          key={index}
        >
          <Typography>{title}</Typography>
          <CreateExcel
            name={`${excelName}-${title}`}
            columnWidths={excelColumnWidth}
            headerValues={excelHeader}
            buttonType="contained"
            data={data}
          />
        </Box>
      ))}
    </div>
  );
};

export default CreateExcelDeliverySampleShuttle;
